import React from 'react';

function NotFoundPage() {
	return <h1>404 Not found</h1>;
}

export default NotFoundPage;
